import React, { useContext, useEffect, useRef, useState } from 'react'
import { Content, ListContent, FilterDiv, FilterImg, FilterText, ButtonCancel, PageBreadcrumb, PageBreadcrumbPrimary, PageBreadcrumbSecondary } from './style'
import { LeftSide, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv, ButtonCreate } from '../../../components/styles/subheader-style'
import orders from '../../../assets/fashion/TableFashionHeader/orders.svg'
import clock from '../../../assets/fashion/TableFashionHeader/clock.svg'
import filter from '../../../assets/stock/TableMovementHeader/filter.svg'
import diskIcon from '../../../assets/addStockModal/pages/disk.svg'
import { Outlet, useNavigate, useOutletContext, useLocation, useParams, useMatch } from 'react-router-dom'
import { TypeMainOutlet } from '..'
import LoadingComponent from '../../../components/LoadingComponent'
import ModuleKanban from '../Pipelines/ModuleKanban'
import { Filter } from 'lucide-react'


interface ProductType {
  id: number
  name: string
  quantity: number
}

export interface FashionOutletType {
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
  addedProducts: ProductType[]
  setAddedProducts: React.Dispatch<React.SetStateAction<ProductType[]>>
  handleSave: React.MutableRefObject<() => void>
  handleEditSave: React.MutableRefObject<() => void>
  search?: string
  isSaving?: boolean
  setIsSaving?: React.Dispatch<React.SetStateAction<boolean>>
}

const tabs = [
  { path: '', image: orders, name: 'Pedidos' },
  { path: 'pre-programming', image: clock, name: 'Pré programação' },
  { path: 'board', image: clock, name: 'Funil' },
]

const FashionSubHeader: React.FC<{
  tabIndexActived: number
  isCreating: boolean
  isEditing: boolean
  isBoardTab: boolean
  onSave?: () => void
  onEditSave?: () => void
}> = ({ tabIndexActived, isCreating, isEditing, isBoardTab, onSave, onEditSave }) => {
const navigate = useNavigate()
const { orderId } = useParams()

return (
  <SubHeaderContainer>
    <LeftSide>
      <SectionName>
        {isCreating
        ? 'Novo pedido: 123456'
        : isEditing
        ? `Editar pedido: ${orderId}`
        : 'Pedidos fashion'}
      </SectionName>
      {!isCreating && !isEditing && (
        <TabsDiv>
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              $isFirst={index === 0}
              $isLast={index === tabs.length - 1}
              $isActive={index === tabIndexActived}
              onClick={() => {
                if (index !== tabIndexActived) navigate(tab.path)
              }}
            >
              {index === 2 ? (
                <Filter size={12.8} style={{ marginRight: 7 }} />
              ) : (
                <img src={tab.image} alt={`${tab.path}-icon`} />
              )}
              {tab.name}
            </Tab>
          ))}
        </TabsDiv>
      )}
    </LeftSide>
    <RightSide>
      {!isCreating && !isEditing && !isBoardTab && (
        <FilterDiv>
          <FilterImg src={filter} alt='filter-icon' />
          <FilterText>Filtrar</FilterText>
        </FilterDiv>
      )}

      {(isCreating || isEditing) && (
        <ButtonCancel
          onClick={() => navigate('/panel/fashion', { replace: true })}
        >
          Cancelar
        </ButtonCancel>
      )}

      {!isBoardTab && (
        <ButtonCreate
          onClick={async () => {
            if (isCreating && onSave) {
              await onSave()
              navigate('/panel/fashion', { replace: true })
            } else if (isEditing && onEditSave) {
              await onEditSave()
              navigate('/panel/fashion', { replace: true })
            } else {
              navigate('/panel/fashion/create')
            }
          }}
        >
          {isCreating ? (
            <>
              <img src={diskIcon} />
              Salvar pedido
            </>
          ) : isEditing ? (
            <>
              <img src={diskIcon} />
              Atualizar pedido
            </>
          ) : (
            '+ Novo pedido'
          )}
        </ButtonCreate>
      )}
    </RightSide>
  </SubHeaderContainer>
)
}

const FashionContent = () => {
  const [tabIndex, setTabIndex] = useState<number>(0)
  const [addedProducts, setAddedProducts] = useState<ProductType[]>(() => {
    const saved = sessionStorage.getItem('addedProducts')
    return saved ? JSON.parse(saved) : []
  })

  const handleSave = useRef<() => void>(() => {})

  const handleEditSave = useRef<() => void>(() => {})

  const [isSaving, setIsSaving] = useState(false)

  const { search } = useOutletContext<TypeMainOutlet>()
  const location = useLocation()
  const navigate = useNavigate()
  const boardMatch = useMatch('/panel/fashion/board')

  const isCreating = location.pathname.includes('/panel/fashion/create')
  const isEditing = location.pathname.startsWith('/panel/fashion/edit/')
  const isBoardTab = !!boardMatch

  useEffect(() => {
    if (location.pathname === '/panel/fashion' || location.pathname === '/panel/fashion/') {
      setTabIndex(0)
    } else if (location.pathname.includes('/panel/fashion/pre-programming')) {
      setTabIndex(1)
    } else if (location.pathname.includes('/panel/fashion/board')) {
      setTabIndex(2)
    }
  }, [location.pathname])


  useEffect(() => {
    sessionStorage.setItem('addedProducts', JSON.stringify(addedProducts))
  }, [addedProducts])

  if (isBoardTab) {
    return (
      <>
        {isSaving && <LoadingComponent />}
        <ModuleKanban
          moduleType="sales"
          moduleName="Vendas Fashion"
          subModule="fashion"
          headerLeftContent={
            <>
              <SectionName>Pedidos fashion</SectionName>
              <TabsDiv>
                {tabs.map((tab, index) => (
                  <Tab
                    key={index}
                    $isFirst={index === 0}
                    $isLast={index === tabs.length - 1}
                    $isActive={index === tabIndex}
                    onClick={() => {
                      if (index !== tabIndex) navigate(tab.path)
                    }}
                  >
                    {index === 2 ? (
                      <Filter size={12.8} style={{ marginRight: 7 }} />
                    ) : (
                      <img src={tab.image} alt={`${tab.path}-icon`} />
                    )}
                    {tab.name}
                  </Tab>
                ))}
              </TabsDiv>
            </>
          }
        />
      </>
    )
  }

  return (
    <>
      {isSaving && <LoadingComponent />}
      <FashionSubHeader
        tabIndexActived={tabIndex}
        isCreating={isCreating}
        isEditing={isEditing}
        isBoardTab={isBoardTab}
        onSave={() => handleSave.current()}
        onEditSave={() => handleEditSave.current()}
      />

      {(isCreating || isEditing) && (
        <PageBreadcrumb>
          <PageBreadcrumbPrimary>Vendas</PageBreadcrumbPrimary>
          <PageBreadcrumbSecondary>&gt; {isCreating ? 'Novo pedido' : 'Editar pedido'}</PageBreadcrumbSecondary>
        </PageBreadcrumb>
      )}

      {(isCreating || isEditing) ? (
        <Content>
          <Outlet
            context={{
              tabIndex,
              setTabIndex,
              addedProducts,
              setAddedProducts,
              handleSave,
              handleEditSave,
              search,
              isSaving,
              setIsSaving: (val: boolean) => {
                setIsSaving(val)
              },
            }}
          />
        </Content>
      ) : (
        <ListContent>
          <Outlet
            context={{
              tabIndex,
              setTabIndex,
              addedProducts,
              setAddedProducts,
              handleSave,
              handleEditSave,
              search,
              isSaving,
              setIsSaving: (val: boolean) => {
                setIsSaving(val)
              },
            }}
          />
        </ListContent>
      )}
    </>
  )
}

export default FashionContent
